const PLURAL_UNIT_LABELS = {
  lbs: 'lb',
  gals: 'gal',
  ozs: 'oz',
  tons: 'ton',
  eas: 'ea',
};

export function singularUnitLabel(unit) {
  if (unit == null) return '';

  const trimmed = String(unit).trim();
  if (!trimmed) return '';

  const mapped = PLURAL_UNIT_LABELS[trimmed.toLowerCase()];
  if (mapped) return mapped;

  if (trimmed.length > 3 && /s$/i.test(trimmed) && !/ss$/i.test(trimmed)) {
    return trimmed.slice(0, -1);
  }

  return trimmed;
}
